import React, { useState } from "react";

import { DeleteOutlined } from "@ant-design/icons";
import { InputNumber, Button, Popconfirm, Table } from "antd";
import { isEmpty } from "lodash-es";

// Types
import { SelectedBaseProduct } from "./ConvertToVirtualKitModal";
// Styles
import * as S from "./SelectedProductsTable.styles";

const PAGE_SIZE = 10;

interface Props {
  selectedProducts: SelectedBaseProduct[];
  disabled?: boolean;
  onProductRemoved: (id: string) => unknown;
  onProductQuantityChanged: (id: string, newQuantity: number) => unknown;
}

const SelectedProductsTable: React.FC<Props> = ({
  selectedProducts,
  disabled,
  onProductRemoved,
  onProductQuantityChanged,
}) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);

  const renderQuantityInput = (quantity: number, product: SelectedBaseProduct) => {
    return (
      <InputNumber
        disabled={disabled}
        value={isNaN(quantity) ? 1 : quantity}
        onChange={(value) => onProductQuantityChanged(product.id, Number(value || 1))}
      />
    );
  };

  const renderRemoveButton = (productID: string) => {
    return (
      <Popconfirm
        title="Are you sure？"
        okText="Yes"
        cancelText="No"
        onConfirm={() => onProductRemoved(productID)}
        disabled={disabled}
      >
        <Button type="text" icon={<DeleteOutlined />} size="small" danger>
          Remove
        </Button>
      </Popconfirm>
    );
  };

  const columns = [
    {
      title: "Product Name",
      dataIndex: "name",
    },
    {
      title: "SKU",
      dataIndex: "sku",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      render: renderQuantityInput,
    },
    {
      title: "Action",
      dataIndex: "id",
      render: renderRemoveButton,
    },
  ];

  return !isEmpty(selectedProducts) ? (
    <S.Container>
      <Table
        columns={columns}
        dataSource={selectedProducts}
        rowKey="id"
        size="small"
        scroll={{ scrollToFirstRowOnChange: true }}
        pagination={{
          current: page,
          pageSize: pageSize,
          total: selectedProducts.length,
          showSizeChanger: true,
          onChange: (page, size = 10) => {
            setPage(page);
            setPageSize(size);
          },
        }}
      />
    </S.Container>
  ) : null;
};

export { SelectedProductsTable };
